// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__20gP0","Logo":"Toolbar_Logo__3PjSY","DesktopOnly":"Toolbar_DesktopOnly__13CA-"};